module.exports = __webpack_public_path__ + "media/img/frontend_application/news-placeholder-ff1a0d0e3439d006b921f021a1fe3628.svg";